<template>
    <u-textarea-outlined-rounded v-bind="$attrs">
        <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
            <slot :name="slotName" />
        </template>
    </u-textarea-outlined-rounded>
</template>

<script>
import UTextareaOutlinedRounded from "@/components/publish/styles/forms/u-textarea-outlined-rounded.vue";

export default {
    props: {},
    components: {
        UTextareaOutlinedRounded,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
